import React from "react";
import PropTypes from "prop-types";

/**
 * Componente Card
 *
 * @component
 * @param {Object} props - As propriedades do componente.
 * @param {ReactNode} props.children - O conteúdo a ser renderizado dentro do card.
 * @param {number} [props.margin=2] - O tamanho da margem para o conteúdo do card.
 * @returns {ReactElement} O elemento React renderizado que representa o card.
 */
function Card({ children, margin = 2, ...props }) {
  return (
    <div className="card" {...props}>
      <div className="card-body">
        <div className={`row m-${margin}`}>
          <div className="col-xl-12 ml-3">
            <React.Fragment>{children}</React.Fragment>
          </div>
        </div>
      </div>
    </div>
  );
}

Card.propTypes = {
  children: PropTypes.node.isRequired,
  margin: PropTypes.number,
};

export default Card;
